import adventCalendar from './adventCarousel';
import snowEffect from './snow';
import countdownTimer from './countdownTimer';

(() => {
  adventCalendar();
  snowEffect();
  countdownTimer();
})();
